import Resume from "./components/Resume";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <Resume />
    </ErrorBoundary>
  );
}

export default App;
